// Listings the seller deleted (P25028-236).
//
// Sharetribe cannot delete a listing through its API, so a deleted listing is closed
// and marked `metadata.isDeleted = true` by `server/api/delete-listing.js`. Everywhere
// the seller looks, it must act as if the listing is gone.

/**
 * Query param that leaves deleted listings out of an own-listings query.
 *
 * Needs a listing search schema with a default, so listings that were never marked
 * still match:
 *   flex-cli search set --key isDeleted --type boolean --scope metadata --default false -m <marketplace>
 * Without the schema, Sharetribe ignores the param and returns every listing.
 */
export const NOT_DELETED_QUERY_PARAMS = { meta_isDeleted: false };

export const isDeletedListing = listing => listing?.attributes?.metadata?.isDeleted === true;
